import React, { useContext } from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'
import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'
import CompactFormRow from 'components/Forms/CompactForm/CompactFormRow/CompactFormRow'

import './event-form-trafi-event-time-module.pcss'

const EventFormTrafiEventTimeModule = ({ label, name }) => {
    const { values } = useContext(ExtendedFormikContext)
    const { t } = useTranslation('events')

    return (
        <EventFormModule className="event-form-trafi-event-time-module">
            <CompactFormRow
                iconName="calendar-alt"
                label={label}
                className="compact-form-date-row"
                trackName={name}
                expandable={false}
            >
                <div className="event-form-trafi-event-time-module__date">
                    {moment(values[name]).format('DD.MM.YYYY')}
                </div>
            </CompactFormRow>
            <div className="event-form-trafi-event-time-module__text">
                {t('events:forms.date.traficomText')}
            </div>
        </EventFormModule>
    )
}

export default EventFormTrafiEventTimeModule
